import React from 'react';
import { H3 } from '../../components';
import css from './SectionOtherServiceLocations.module.css';

const SectionOtherServiceLocations = ({ locations = [] }) => {
  const otherLocations = locations.filter(l => !l.isActive);

  if (!otherLocations.length) return null;

  return (
    <section className={css.root}>
     <div className={css.locationWrapper}>
         <H3 as="h2" className={css.title}>
        Other service locations
      </H3>

      <ul className={css.list}>
        {otherLocations.map((loc, i) => (
          <li key={i} className={css.item}>
            <div className={css.address}>
              {loc.location?.address}
            </div>
            {loc.radius ? (
              <div className={css.radius}>
                Service radius: {loc.radius} km
              </div>
            ) : null}
          </li>
        ))}
      </ul>
     </div>
    </section>
  );
};

export default SectionOtherServiceLocations;
